export enum PersonnemoraleTypes {
  ASSOCIE = 'ASSOCIE',
  CLIENT = 'CLIENT',
  FOURNISSEUR = 'FOURNISSEUR',
}
